import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as calendarioActions from '../../reducers/CalendarioReducer/actions'
import { calendarioPickupSelector,calendarioDeliverySelector } from '../../selectors/calendarioSelector'
import { instalacionSelector } from '../../selectors/sessionSelector'
import Calendario from '../../components/Calendario'
import PropTypes from 'prop-types';
class CalendarioContainer extends React.Component {

    constructor(props) {
        super(props)
     
        this.getCalendario(1)   // pickup
        this.getCalendario(2)   // delivery
    }
    
    getCalendario = (idTipoCalendario) => {
      const payload = {
        idTipoCalendario: idTipoCalendario,
        idInstalacion: this.props.instalacion.id,
        idRecurso: 1
      }

      this.props.sagaFetchCalendario(payload);
    }

    render() {
       
        return (
            <Calendario
              calendarioPickup={this.props.calendarioPickup}
              calendarioDelivery={this.props.calendarioDelivery}
              handleOnClose={this.props.handleOnClose}
              
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...calendarioActions,
    
  }, dispatch)
}

function mapStateToProps(state) {
  return {
    instalacion: instalacionSelector(state),
    calendarioPickup: calendarioPickupSelector(state),
    calendarioDelivery:calendarioDeliverySelector(state),
  }
}

CalendarioContainer.propTypes = {
  handleOnClose:PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarioContainer)